import React, { Component } from 'react';
import { AppConstants } from '../../core/constants';
import { fixNumbers } from '../../core/utils';
import service from '../../core/service';
import * as yup from 'yup';
import { toast } from 'react-toastify';



interface IProps {

}

interface IState {
  str: string;
  anchorEl: null | HTMLElement;
  open: any,
  openAddModal: boolean;
  openActionModal: boolean;
  loading: boolean;
  dealsModelsList?: any;
  page: number;
  count: number;
  subject: string;
  errorsList:any;
  openEditModal: boolean;
  selectedItem:any;
  openConfirmModal:boolean;
  rowsCountList:any;




}

export class DealsModelController extends Component<IProps, IState> {

  datePickerRef: any;

  constructor(props: any) {
    super(props);
    this.datePickerRef = React.createRef();
  }

  state: IState = {
    str: "",
    anchorEl: null,
    open: false,
    openAddModal: false,
    openActionModal: false,
    loading: false,
    dealsModelsList: [],
    page: 1,
    errorsList:[],
    subject: "",
    count: 6,
    openEditModal: false,
    selectedItem:null,
    openConfirmModal: false,
    rowsCountList:[6, 10, 50, 100],

  };
  handleClick = (event: React.MouseEvent<HTMLElement>) => {
    this.setState({ anchorEl: this.state.anchorEl ? null : event.currentTarget });
    this.setState({ open: this.state.anchorEl ? null : Boolean(event.currentTarget) });

  };
  emptyCount= () => {
    this.setState({ count: 6, page:1 });
  };
  paginationRowTimeOut: string | number | NodeJS.Timeout | undefined;
  handleCount = (value: any) => {
    this.setState({ count: value, page:1 });
    clearTimeout(this.paginationRowTimeOut);
    this.paginationRowTimeOut = setTimeout(() => {
      this.getDealsModels()
    }, 800);
  }
  getDealsModels = async () => {
    this.setState({ loading: true })
    const { page, count } = this.state;
    let parameters = {
      page: page ? page.toString() : "1",
      count: count ? count.toString() : "6",

    }
    let url = new URL(`${AppConstants.base_url_api}lead/deals/`)
    for (const [key, value] of Object.entries(parameters)) {
      if (value) {
        url.searchParams.append(key, value)
      }
    }
    try {
      const response = await service.Deals.modelList(url.search);
      if (response) {
        this.setState({ dealsModelsList: response?.data?.data, openAddModal: false, loading: false })
      } else {
        this.setState({ loading: false })
      }
    } catch (error) {
      // throw error;
    }
  };
  paginationTimeOut: string | number | NodeJS.Timeout | undefined;
  handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    this.setState({ page: value })
    clearTimeout(this.paginationTimeOut);
    this.paginationTimeOut = setTimeout(() => {
      this.getDealsModels()
    }, 800);
  }

  handleRemove = (item:any) =>{
    this.setState({selectedItem: item, openConfirmModal: true});
  }
 async confirmDelete  () {
  const { selectedItem } = this.state;
    const response = await service.Deals.delete(selectedItem?.id);
    if (response) {
      if(response.status === 200){
        toast.success("با موفقیت حذف شد");
        this.setState({selectedItem:null, openConfirmModal: false});
        this.getDealsModels();

      }
      else{
        toast.error("مشکلی پیش آمده‌است");
      }
    } else {
      this.setState({ loading: false, openConfirmModal: false });
      toast.error("مشکلی پیش آمده‌است");
    }
  }
  handleUpdate = (item:any) =>{
    this.setState({selectedItem: item, openEditModal: true, subject: item?.subject})

  }
  async sendUpdate () {
    const { subject, selectedItem } = this.state;
    const schema = yup.object({
        subject: yup.string().required(" عنوان اجباری می‌باشد"),
        });   
        try {
          await schema.validate({ subject }, { abortEarly: false });
          const response = await service.Deals.update( subject, selectedItem?.id );
            if (response) {
                if(response?.status === 200){
                    this.setState({ errorsList:[], openEditModal: false, subject:"", selectedItem:null });
                    this.getDealsModels();
                    toast.success("با موفقیت ارسال شد");
                }
                else{
                    toast.error("مشکلی پیش آمده‌است");
                }
            } else {
                this.setState({ loading: false });
                toast.error("مشکلی پیش آمده‌است");

            }  
        } catch (err: any) {
          this.setState({ errorsList: err.inner  })
        }
  }
  async handleNewTransaction () {
    const { subject } = this.state;
    const schema = yup.object({
        subject: yup.string().required(" عنوان اجباری می‌باشد"),
        });   
        try {
          await schema.validate({ subject }, { abortEarly: false });
          const response = await service.Deals.create( subject );
            if (response) {
                if(response?.status === 200){
                    this.setState({ errorsList:[], openAddModal: false, subject:"" });
                    this.getDealsModels();
                    toast.success("با موفقیت ارسال شد");
                }
                else{
                    toast.error("مشکلی پیش آمده‌است");
                }
            } else {
                this.setState({ loading: false });
                toast.success("با موفقیت ارسال شد");

            }  
        } catch (err: any) {
          this.setState({ errorsList: err.inner  })
        }
  }
}
export default DealsModelController;